export default "__VITE_ASSET__dd16de80__"